import type { CSSProperties } from "react";

export interface HeaderProps {
	mods?: string | undefined;
	style?: CSSProperties;
	children: React.ReactNode;
}

export function Header({ mods = "", style, children }: HeaderProps): React.ReactElement {
	return (
		<header className={`panel ${mods}`} style={style}>
			{children}
		</header>
	);
}
